"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalCounter = 0;
var generateId = function (prefix) {
    if (prefix === void 0) { prefix = 'cosmos'; }
    prefix = prefix.toLowerCase().replace(/ /g, '_');
    return prefix + '-' + globalCounter++;
};
exports.default = generateId;
//# sourceMappingURL=uniqueId.js.map